<div class="kml-import-page-container">
  <div class="container">
    <div class="row">
      <div class="col-md-12 pt-5 pb-3">
        <h1 class="mat-headline-4 text-center">Spot Import from KML</h1>
        <p class="mat-body">
          Here you can upload KML files to transfer spots to PK Spot for free.
          Anyone can then see, share and review the uploaded spots.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <mat-horizontal-stepper
          [linear]="true"
          #stepperHorizontal
          color="primary"
        >
          <!-- Icon overrides -->
          <ng-template matStepperIcon="select">
            <mat-icon>description</mat-icon>
          </ng-template>
          <ng-template matStepperIcon="setup">
            <mat-icon>settings</mat-icon>
          </ng-template>
          <ng-template matStepperIcon="import">
            <mat-icon>add</mat-icon>
          </ng-template>
          <ng-template matStepperIcon="verify">
            <mat-icon>where_to_vote</mat-icon>
          </ng-template>
          <ng-template matStepperIcon="save">
            <mat-icon>publish</mat-icon>
          </ng-template>
          <ng-template matStepperIcon="done">
            <mat-icon>done</mat-icon>
          </ng-template>

          <!-- Steps -->
          <!-- Select step -->
          <mat-step [stepControl]="uploadFormGroup!" state="select">
            <ng-template matStepLabel
              ><span class="d-none d-md-block">Select</span></ng-template
            >
            <form class="pt-3 px-3" [formGroup]="uploadFormGroup!">
              <h3 class="mat-h3">Please select a KML file.</h3>
              <app-media-upload
                [allowedMimeTypes]="[
                  'application/xml',
                  'text/xml',
                  'application/vnd.google-earth.kml+xml'
                ]"
                acceptString=".kml, .xml"
                [required]="true"
              ></app-media-upload>
              <div class="mt-5">
                <button
                  mat-raised-button
                  color="accent"
                  class="float-right"
                  [disabled]="!kmlUploadFile"
                  (click)="continueToSetup()"
                >
                  Continue to setup
                </button>
              </div>
            </form>
          </mat-step>

          <!-- Setup step -->
          <mat-step [stepControl]="setupFormGroup!" state="setup">
            <ng-template matStepLabel
              ><span class="d-none d-md-block">Import Setup</span></ng-template
            >
            <form class="px-3" [formGroup]="setupFormGroup!">
              <div class="container d-lg-block mt-3">
                <div class="row">
                  <div class="col-md-6">
                    <div class="kml-preview" *ngIf="kmlParserService.setupInfo">
                      <h2 class="mat-h2">Preview</h2>
                      <div class="px-3">
                        <h3 class="mat-h3">
                          <b>{{ kmlParserService.setupInfo.name }}</b>
                        </h3>
                        <p class="mat-body">
                          {{ kmlParserService.setupInfo.description }}
                        </p>
                        <p class="mat-body">
                          <b
                            >{{ kmlParserService.setupInfo.spotCount }} Spots</b
                          >
                          accross
                          <b
                            >{{
                              kmlParserService.setupInfo.folders.length
                            }}
                            folders</b
                          >.
                        </p>
                      </div>
                    </div>

                    <h2 class="mat-h2">Import Settings</h2>
                    <mat-form-field
                      class="w-100"
                      appearance="outline"
                      *ngIf="kmlParserService.setupInfo"
                    >
                      <mat-label>Language</mat-label>
                      <input
                        type="text"
                        matInput
                        formControlName="setupLangCtrl"
                        [matAutocomplete]="auto"
                        required
                      /><mat-autocomplete #auto="matAutocomplete">
                        @for(lang of languages; track lang) {
                        <mat-option
                          [value]="lang"
                          (onSelectionChange)="
                            kmlParserService.setupInfo.lang = lang
                          "
                        >
                          {{ lang }}
                        </mat-option>
                        }
                      </mat-autocomplete>
                      <mat-icon
                        matSuffix
                        matTooltip="The language of the spot names"
                        >help_outline</mat-icon
                      >
                    </mat-form-field>

                    <div class="mt-2">
                      <mat-slide-toggle
                        #regexToggle
                        color="accent"
                        [checked]="false"
                        (change)="setRegexEnabled($event.checked)"
                        >RegEx for Spot name</mat-slide-toggle
                      >

                      <mat-form-field class="w-100 py-3" appearance="outline">
                        <mat-label>Name RegEx</mat-label>
                        <app-regex-input
                          #regex
                          formControlName="setupRegexCtrl"
                          flagsString="gim"
                          [disabledFlags]="true"
                          [disabled]="!regexToggle.checked"
                          [value]="{
                            regularExpression: '([^-]*)$',
                            expressionFlags: 'gim'
                          }"
                          (valueChange)="updateRegex($event)"
                        ></app-regex-input>
                        <mat-icon
                          matSuffix
                          matTooltip="You can provide a regular expression that will be applied to every imported spot name. The first capturing group will be used as the new spot name. Spot names that don't produce any matches will need to be checked by you on step 4. Visit https://regexr.com/ for help."
                          >help_outline</mat-icon
                        >
                        <mat-hint *ngIf="!regex.errorState && !regex.disabled"
                          >The first capturing group is used as the spot
                          name.</mat-hint
                        >
                        <mat-error *ngIf="regex.errorState">{{
                          regex.getErrorMessage()
                        }}</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h2 class="mat-h2">Folders to import</h2>
                    <span
                      *ngIf="kmlParserService.setupInfo?.folders"
                      class="example-list-section"
                    >
                      <ul class="checkbox-list">
                        @for(folder of kmlParserService.setupInfo?.folders;
                        track folder) {
                        <li>
                          <mat-checkbox
                            *ngIf="folder"
                            color="accent"
                            [checked]="folder.import"
                            (change)="folder.import = $event.checked"
                          >
                            {{ folder.name }} ({{ folder.spotCount }} Spots)
                          </mat-checkbox>
                        </li>
                        }
                      </ul>
                    </span>
                    <p
                      *ngIf="
                        !kmlParserService.setupInfo?.folders ||
                        (kmlParserService.setupInfo?.folders)!.length === 0
                      "
                      class="mat-body"
                    >
                      No folders in KML file.
                    </p>
                  </div>
                </div>
              </div>

              <div class="mt-3 d-flex flex-row justify-content-between">
                <button mat-flat-button class="float-left" (click)="goBack()">
                  Return to File Selection
                </button>
                <button
                  mat-flat-button
                  class="float-right"
                  color="accent"
                  [disabled]="setupFormGroup?.invalid || regex.errorState"
                  (click)="continueToVerification()"
                >
                  Continue
                </button>
              </div>
            </form>
          </mat-step>

          <mat-step state="verify">
            <ng-template matStepLabel
              ><span class="d-none d-md-block">Verify</span></ng-template
            >
            <div class="container">
              <div class="row">
                <div class="col-md-5 verify-acc-col">
                  <mat-accordion>
                    <mat-expansion-panel class="mat-elevation-z0">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          Spots to be imported
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div>
                        @for(spot of kmlParserService.spotsToImport$ | async;
                        track spot) {
                        <button
                          mat-flat-button
                          class="text-truncate"
                          (click)="selectedVerificationSpot = spot"
                        >
                          {{ spot.spot.name }}
                        </button>
                        }
                      </div>
                    </mat-expansion-panel>
                    <mat-divider></mat-divider>
                    <mat-expansion-panel class="mat-elevation-z0">
                      <mat-expansion-panel-header>
                        <mat-panel-title>Will not be imported</mat-panel-title>
                      </mat-expansion-panel-header>
                      <div>
                        @for(spot of kmlParserService.spotsNotToImport$ | async;
                        track spot) {
                        <button
                          mat-flat-button
                          class="text-truncate"
                          (click)="selectedVerificationSpot = spot"
                        >
                          {{ spot.spot.name }}
                        </button>
                        }
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
                <div class="col-md-7">
                  <div *ngIf="selectedVerificationSpot" class="p-2">
                    <h3 class="mat-h2">
                      {{ selectedVerificationSpot.spot.name }}
                    </h3>
                    <p>Folder: {{ selectedVerificationSpot.folder }}</p>
                    <div class="map-container">
                      <app-spot-map
                        #spotMap
                        id="spotMap"
                        [markers]="
                          getSpotMarkers(
                            kmlParserService.spotsToImport$ | async
                          )
                        "
                        [selectedMarker]="
                          selectedVerificationSpot.spot.location
                        "
                        [isClickable]="false"
                      ></app-spot-map>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-3 d-flex flex-row justify-content-between">
                <button mat-button (click)="goBack()">Return to Setup</button>
                <button
                  mat-flat-button
                  matStepperNext
                  color="warn"
                  (click)="importSpots()"
                >
                  Import Spots
                </button>
              </div>
            </div>
          </mat-step>
          <mat-step [editable]="false" state="save">
            <ng-template matStepLabel
              ><span class="d-none d-md-block">Save</span></ng-template
            >
          </mat-step>
          <mat-step [editable]="false" state="done">
            <ng-template matStepLabel
              ><span class="d-none d-md-block">Done</span></ng-template
            >
            <p>You are now done.</p>
            <div>
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button (click)="stepperHorizontal.reset()">
                Reset
              </button>
            </div>
          </mat-step>
        </mat-horizontal-stepper>
      </div>
    </div>
  </div>
</div>
